import { configAppScope, configApp, initialLanguageEdit, initialLanguageCurrent } from "@/service/appList";
import LineOrgTag from "@/components/FragmentTemplate/LineOrgTag";
export default {
  name: "AppDetailTab1",
  components: {
    LineOrgTag
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    downAddress: {
      type: Object,
      default() {
        return {};
      }
    },
    scopeList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      loading: false,
      languageList: [{
        title: $t("yd413r5", "中文(简)"),
        value: "zh-CN"
      }, {
        title: $t("yd4hyu5", "中文(繁)"),
        value: "zh-TW"
      }, {
        title: "English",
        value: "en-US"
      }, {
        title: $t("82m34e9", "跟随iWork系统"),
        value: "@CURRENT@"
      }],
      languageValue: ""
    };
  },
  computed: {
    // 下载地址控制
    _showDown() {
      let appCodes = ["iHotel", "PosClient", "iGroup", "MIHOTEL"];
      return appCodes.some(v => v === this.detail.appCode);
    },
    _unitId() {
      return this.$store.state.user.userInfo.unitId;
    },
    _language() {
      return this.item.id === "ID_OPERA_CLOUD";
    }
  },
  watch: {
    "detail.appId"(id) {
      if (id && id === "ID_OPERA_CLOUD") {
        this.getInitLanguage();
      }
    }
  },
  methods: {
    /*
     * 应用状态
     */
    async changeConfig(val) {
      this.loading = true;
      let res = await configAppScope({
        appId: this.item.id,
        unitId: this._unitId,
        isHalt: val
      });
      if (res.data && res.data.result == 0) {
        this.$Message.success(val === "F" ? $t("cc5y4e4", "开启成功") : $t("aw9ka14", "关闭成功"));
        this.detail.isHalt = val;
      } else {
        this.detail.isHalt = val === "T" ? "F" : "T";
      }
      this.loading = false;
    },
    /*
     * 点击下载地址开始输入
     */
    onChangeEditAddress() {
      this.$nextTick(() => {
        this.$refs["downAddressInput"].focus();
      });
    },
    /*
     * 打开使用人员弹窗
     */
    openAddOrgUser() {
      this.$emit("on-change-user");
    },
    /*
     * 星级
     */
    async setConfig() {
      await configApp({
        appId: this.item.id,
        unitId: this._unitId,
        ...this.detail
      });
    },
    async getInitLanguage() {
      const params = {
        appCode: this.detail.appCode
      };
      let {
        data
      } = await initialLanguageCurrent(params);
      if (data && data.result == 0) {
        this.languageValue = data.retVal || "en-US";
      }
    },
    /*
     * 切换语言
     */
    async onChangeLanguage(language) {
      let {
        data
      } = await initialLanguageEdit({
        appCode: this.detail.appCode,
        language: language
      });
      if (data && data.result == 0) {
        this.$Message.success($t("ai8d7e4", "修改成功"));
        this.languageValue = language;
      }
    }
  }
};